import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import './filterslidepanel.scss'

// Actions
import { closeSlidePanel } from '../../../../actions/common'
import { getFilterOrderingSparePartsDetails, getFilterReceptionSparePartsDetails, getSparePartsOrdering, getSparePartsReception } from '../../../../actions/spareparts'

// Helpers
import { translation } from '../../../../utils/helpers'

// Elements
import SlidePanel from '../../../elements/slidePanel'
import BottomBar from '../../../elements/bottomBar'
import Inline from '../../../elements/inline'
import Check from '../../../elements/check'

class FilterSlidePanel extends Component {
  constructor (props) {
    super(props)

    this.state = {
      filterDetails: [],
      isLoading: false,

      selectedSuppliers: [],
      selectedStatuses: []
    }

    this.clearFilters = this.clearFilters.bind(this)
  }

  componentDidUpdate (prevProps) {
    const { view, filter } = this.props

    if (view !== prevProps.view) {
      this.getFilterDetails()
    }

    // Update filter selected values
    if (!isEqual(filter, prevProps.filter)) {
      this.setState({
        selectedSuppliers: filter.SupplierIds,
        selectedStatuses: filter.Statuses
      })
    }
  }

  getFilterDetails () {
    const { view, type } = this.props

    let filterType = 1 // Status
    if (view === 'supplier') {
      filterType = 2 // Supplier
    }

    const data = {
      OrderId: this.props.orderId,
      FilterType: filterType
    }

    this.setState({ isLoading: true }, () => {
      switch (type) {
        case 'ordering':
        default:
          this.props.getFilterOrderingSparePartsDetails(data).then(res => {
            this.setState({
              filterDetails: res.data,
              isLoading: false
            })
          })
          break
        case 'reception':
          this.props.getFilterReceptionSparePartsDetails(data).then(res => {
            this.setState({
              filterDetails: res.data,
              isLoading: false
            })
          })
          break
      }
    })
  }

  submitFilter (filterType) {
    let filterObj = {
      OrderId: this.props.orderId
    }

    if (filterType === 'supplier') {
      filterObj.SupplierIds = this.state.selectedSuppliers
      filterObj.SelectedFilters = 2
    } else if (filterType === 'status') {
      filterObj.Statuses = this.state.selectedStatuses
      filterObj.SelectedFilters = 1
    }

    this.setState({ isLoading: true }, () => {
      if (this.props.type === 'ordering') {
        this.props.getSparePartsOrdering(filterObj).then(res => {
          this.closeSlidePanel()
        })
      } else {
        this.props.getSparePartsReception(filterObj).then(res => {
          this.closeSlidePanel()
        })
      }
    })
  }

  closeSlidePanel () {
    if (this.props.onClose) this.props.onClose()
    this.props.closeSlidePanel('sparePartsFilter')
    this.setState({ isLoading: false })
  }

  clearFilters () {
    let hasFilters = this.props.filter.SelectedFilters !== 0
    if (hasFilters) {
      this.setState({ isLoading: true }, () => {
        if (this.props.type === 'ordering') {
          this.props.getSparePartsOrdering({ OrderId: this.props.orderId }).then(res => {
            this.closeSlidePanel()
          })
        } else {
          this.props.getSparePartsReception({ OrderId: this.props.orderId }).then(res => {
            this.closeSlidePanel()
          })
        }
      })
    } else {
      this.closeSlidePanel()
    }
  }

  getCancelText () {
    if (this.props.filter.SelectedFilters === 0) {
      return translation('1155')
    } else {
      return translation('16658')
    }
  }

  renderSpinner (small = false) {
    if (small) {
      return (
        <span className='animated-background'>
          <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
        </span>
      )
    }

    return (
      <div className='animated-background'>
        <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
      </div>
    )
  }

  renderSupplierView () {
    const renderSupplierGroup = (supplierGroup, key) => {
      const onChange = (e) => {
        const { value, checked } = e.target
        const val = parseInt(value, 10)

        if (checked) {
          this.setState({
            selectedSuppliers: [
              ...this.state.selectedSuppliers,
              val
            ]
          })
        } else {
          this.setState({
            selectedSuppliers: [
              ...this.state.selectedSuppliers.filter(ss => ss !== val)
            ]
          })
        }
      }

      return (
        <Inline fillChildNum={[0]} block key={key}>
          <Check
            name='supplier'
            value={supplierGroup.SupplierId}
            onChange={onChange}
            checked={this.state.selectedSuppliers.includes(supplierGroup.SupplierId)}
            labelText={supplierGroup.SupplierName || translation('15392')}
            disabled={supplierGroup.Count === 0}
          />
          <div className='filter-count'>{supplierGroup.Count}</div>
        </Inline>
      )
    }

    const selectedCount = this.state.filterDetails.reduce((sum, detail) => {
      if (this.state.selectedSuppliers.includes(detail.SupplierId)) {
        return sum + detail.Count
      }
      return sum
    }, 0)
    const actionText = translation('16656').replace('[count]', selectedCount)

    return [
      <div className='top' key={0}>
        <h1 className='title'>{translation(16657)}</h1>
      </div>,

      <div className='content filter' key={1}>
        {this.state.isLoading && this.renderSpinner()}
        {!this.state.isLoading && this.state.filterDetails.map(renderSupplierGroup)}
      </div>,

      <BottomBar
        disabled={this.state.isLoading || this.state.selectedSuppliers.length === 0}
        actionLabelText={this.state.isLoading ? this.renderSpinner(true) : actionText}
        onActionClick={() => this.submitFilter('supplier')}
        cancelLabelText={this.getCancelText()}
        onCancelClick={this.clearFilters}
        key={2}
      />
    ]
  }

  renderStatusView () {
    const renderStatusGroup = (statusGroup, key) => {
      const onChange = (e) => {
        const { name, value, checked } = e.target
        const val = parseInt(value, 10)

        console.log('status change', { name, val, checked })
        if (checked) {
          this.setState({
            selectedStatuses: [
              ...this.state.selectedStatuses,
              val
            ]
          })
        } else {
          this.setState({
            selectedStatuses: [
              ...this.state.selectedStatuses.filter(ss => ss !== val)
            ]
          })
        }
      }

      let labelText
      switch (statusGroup.Status) {
        case 1:
          labelText = translation('15392')
          break
        case 2:
          labelText = translation('16449')
          break
        case 4:
          labelText = translation('14799')
          break
        case 8:
          labelText = this.props.type === 'ordering' ? translation('16457') : translation('16535')
          break
        case 16:
          labelText = translation('16452')
          break
        case 32:
          labelText = translation('16453')
          break
        case 64:
          labelText = translation('16454')
          break
        case 128:
          labelText = translation('18108')
          break
        case 0:
          return null
      }
      return (
        <Inline fillChildNum={[0]} block key={key}>
          <Check
            name='status'
            value={statusGroup.Status}
            onChange={onChange}
            checked={this.state.selectedStatuses.includes(statusGroup.Status)}
            labelText={labelText}
            disabled={statusGroup.Count === 0}
          />
          <div className='filter-count'>{statusGroup.Count}</div>
        </Inline>
      )
    }

    const selectedCount = this.state.filterDetails.reduce((sum, detail) => {
      if (this.state.selectedStatuses.includes(detail.Status)) {
        return sum + detail.Count
      }
      return sum
    }, 0)
    const actionText = translation('16656').replace('[count]', selectedCount)

    return [
      <div className='top' key={0}>
        <h1 className='title'>{'Status'}</h1>
      </div>,

      <div className='content filter' key={1}>
        {this.state.isLoading && this.renderSpinner()}
        {!this.state.isLoading && this.state.filterDetails.map(renderStatusGroup)}
      </div>,

      <BottomBar
        disabled={this.state.isLoading || this.state.selectedStatuses.length === 0}
        actionLabelText={this.state.isLoading ? this.renderSpinner(true) : actionText}
        onActionClick={() => this.submitFilter('status')}
        cancelLabelText={this.getCancelText()}
        onCancelClick={this.clearFilters}
        key={2}
      />
    ]
  }

  render () {
    let content = null
    switch (this.props.view) {
      case 'supplier':
      default:
        content = this.renderSupplierView()
        break
      case 'status':
        content = this.renderStatusView()
        break
    }

    return (
      <div className='filterSlidePanel'>
        <SlidePanel slidePanelId='sparePartsFilter'>
          {content}
        </SlidePanel>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  closeSlidePanel,
  getFilterOrderingSparePartsDetails,
  getFilterReceptionSparePartsDetails,
  getSparePartsOrdering,
  getSparePartsReception
})(FilterSlidePanel)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/spareParts/filterSlidePanel/index.js